import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFaq = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "ç»æ¿",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "ç©å½¢",
				d: "M17.0834 1.66663H2.91669C2.22633 1.66663 1.66669 2.22627 1.66669 2.91663V17.0833C1.66669 17.7736 2.22633 18.3333 2.91669 18.3333H17.0834C17.7737 18.3333 18.3334 17.7736 18.3334 17.0833V2.91663C18.3334 2.22627 17.7737 1.66663 17.0834 1.66663Z",
				stroke: "",
				strokeWidth: 1.4
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "è·¯å¾",
				d: "M6.25 1.66663L6.25 18.3333",
				stroke: "",
				strokeWidth: 1.4,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "è·¯å¾_2",
				d: "M1.66669 7.0991L18.3334 7.08337",
				stroke: "",
				strokeWidth: 1.4,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "è·¯å¾å¤ä»½ 2",
				d: "M1.66669 12.7162L18.3334 12.7004",
				stroke: "",
				strokeWidth: 1.4,
				strokeLinecap: "round"
			})
		]
	})
});
export default SvgFaq;
